"use strict";
module.exports = ['$translate', '$http', '$httpParamSerializer', 'ngDroUAACommon', function ($translate, $http, $httpParamSerializer, ngDroUAACommon) {

        this.findAll = function (pageable,query, usePrefix) {
            ngDroUAACommon.setUsePrefix(usePrefix || true);

            var params = {
                page: pageable.pageNumber,
                size: pageable.size,
                sort: pageable.sorting + ',' + pageable.order,
                q: query || ''
            };

            return $http({
                method: 'GET',
                withCredentials: true,
                url: ngDroUAACommon.getUrl('api/person'),
                params: params
            });
        };

        this.findOne = function (id, usePrefix) {
            ngDroUAACommon.setUsePrefix(usePrefix || true);

            return $http({
                method: 'GET',
                withCredentials: true,
                url: ngDroUAACommon.getUrl('api/person/' + id)
            });
        };
        
        this.findOneByCompanyDistrict = function (id, usePrefix) {
            ngDroUAACommon.setUsePrefix(usePrefix || true);

            return $http({
                method: 'GET',
                withCredentials: true,
                url: ngDroUAACommon.getUrl('api/person/company/' + id)
            });
        };

        this.update = function (data, usePrefix) {
            ngDroUAACommon.setUsePrefix(usePrefix || true);

            return $http({
                method: 'PUT',
                withCredentials: true,
                url: ngDroUAACommon.getUrl('api/person'),
                data: data
            });
        };

        this.delete = function (id, usePrefix) {
            ngDroUAACommon.setUsePrefix(usePrefix || true);

            return $http({
                method: 'DELETE',
                withCredentials: true,
                url: ngDroUAACommon.getUrl('api/person/' + id)
            });
        };

        this.save = function (data, usePrefix) {
            ngDroUAACommon.setUsePrefix(usePrefix || true);

            return $http({
                method: 'POST',
                withCredentials: true,
                url: ngDroUAACommon.getUrl('api/person'),
                data: data
            });
        };
        
        return {
            findAll: this.findAll,
            findOne: this.findOne,
            findOneByCompanyDistrict: this.findOneByCompanyDistrict,
            update: this.update,
            delete: this.delete,
            save: this.save
        };
    }];



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/services/rest/person.js
// module id = 395
// module chunks = 0